(function (Drupal, once) {
  Drupal.behaviors.hslTabs = {
    attach(context) {
      if (typeof window === "undefined") {
        return;
      }

      once("hsl-tabs", ".hsl-tabs", context).forEach((tabsComponent) => {
        const tabsList = tabsComponent.querySelector(".hsl-tabs__tabs");
        if (!tabsList) {
          return;
        }

        const tabItems = tabsList.querySelectorAll("li");
        const tabContents = tabsComponent.querySelectorAll(
          ".hsl-tabs__tab-content",
        );

        if (tabItems.length === 0 || tabContents.length === 0) {
          return;
        }

        function activateTab(index) {
          tabItems.forEach((item) => {
            item.classList.remove("active");
          });

          tabContents.forEach((content) => {
            content.classList.remove("active");
          });

          if (tabItems[index]) {
            tabItems[index].classList.add("active");
          }

          if (tabContents[index]) {
            tabContents[index].classList.add("active");
          }
        }

        activateTab(0);

        tabItems.forEach((tabItem, index) => {
          tabItem.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            activateTab(index);
          });
        });
      });
    },
  };
})(Drupal, once);
